import { render, staticRenderFns } from "./QuickApprover.vue?vue&type=template&id=ab8f0f6c&"
import script from "./QuickApprover.vue?vue&type=script&lang=js&"
export * from "./QuickApprover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports